import { Injectable } from '@angular/core';
import { UIService } from './ui.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LocalService {
  constructor(private ui: UIService, private router: Router) {
    this.loadProfile();
  }

  private static KEY = 'IHGadmin';
  private _globalProfile: any = {};

  public get(key: string, defaultVal: any = null) {
    return this._globalProfile[key] ?? defaultVal;
  }

  public set(key: string, value: any) {
    if (JSON.stringify(this._globalProfile[key]) !== JSON.stringify(value)) this._globalProfile[key] = value;
    localStorage.setItem(LocalService.KEY, JSON.stringify(this._globalProfile));
  }

  private loadProfile() {
    this._globalProfile = {};
    const rawGlobal = localStorage.getItem(LocalService.KEY);
    const globalData = rawGlobal && JSON.parse(rawGlobal);
    if (globalData) {
      this._globalProfile = globalData;
    }
  }
}
